import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';
import { sdiCodeToIta, sdiCodeToClass, sdiCodeToIcon } from 'beebee-base/lib/utility';
import { debug } from '@ember/debug';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
let InvoicesNotificheSdiModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('boolean', {
  defaultValue: false
}), _class = class InvoicesNotificheSdiModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "cli_sdi_sezionale", _descriptor, this);
    _initializerDefineProperty(this, "cli_sdi_num_fattura", _descriptor2, this);
    _initializerDefineProperty(this, "cli_sdi_data_fattura", _descriptor3, this);
    _initializerDefineProperty(this, "cli_sdi_codice_destinatario", _descriptor4, this);
    _initializerDefineProperty(this, "cli_sdi_stato", _descriptor5, this);
    _initializerDefineProperty(this, "cli_sdi_id", _descriptor6, this);
    _initializerDefineProperty(this, "cli_sdi_name", _descriptor7, this);
    _initializerDefineProperty(this, "cli_sdi_created", _descriptor8, this);
    _initializerDefineProperty(this, "errori", _descriptor9, this);
    _initializerDefineProperty(this, "created_at", _descriptor0, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor1, this);
  }
  get errori_json() {
    if (this.errori) {
      let parseError = {};
      try {
        parseError = JSON.parse(this.errori);
      } catch (e) {
        debug(e);
        const erroriCorretti = this.errori.replace(/("Suggerimento"\s*:\s*)"([^"}]*)"([^"}]*)"}/, '$1"$2$3"}');
        try {
          parseError = JSON.parse(erroriCorretti);
        } catch (e2) {
          debug(e2);
          return null;
        }
      }
      if (parseError?.Errore && !Array.isArray(parseError.Errore)) {
        parseError.Errore = [parseError.Errore];
      }
      return parseError;
    }
    return null;
  }
  get cli_sdi_stato_ita() {
    return sdiCodeToIta(this.cli_sdi_stato);
  }
  get cli_sdi_class() {
    return sdiCodeToClass(this.cli_sdi_stato);
  }
  get cli_sdi_icon() {
    return sdiCodeToIcon(this.cli_sdi_stato);
  }
  get show_help() {
    return (this.cli_sdi_stato === 'HDO07' || this.cli_sdi_stato === 'HDO02') && this.errori;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_sezionale", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_num_fattura", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_data_fattura", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_codice_destinatario", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_stato", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_id", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_name", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "cli_sdi_created", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "errori", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoicesNotificheSdiModel as default };
//# sourceMappingURL=invoices_notifiche_sdi.js.map
